<template>
  <div class="my-2 p-2 bg-sh-pale-grey">
    <div class="flex justify-between">
      <div v-if="itemAlignment" class="flex flex-col items-center">
        <div>
          <base-icon-group>
            <base-icon
              name="center-horizontal-icon"
              size="sm"
              @click.native="closeModalAfter(() => centerElementHorizontally())"
            />
            <base-icon
              name="center-vertical-icon"
              size="sm"
              @click.native="closeModalAfter(() => centerElementVertically())"
            />
          </base-icon-group>
        </div>
        <span class="text-xxs mt-1">
          {{ $t('customization.itemAlignCenter') }}
        </span>
      </div>
      <div v-if="layering" class="flex flex-col items-center">
        <div>
          <base-icon-group>
            <base-icon name="to-back" size="sm" @click.native="moveToBack" />
            <base-icon name="to-front" size="sm" @click.native="moveToFront" />
          </base-icon-group>
        </div>
        <span class="text-xxs mt-1">{{ $t('customization.itemRelayer') }}</span>
      </div>
      <div
        v-if="textAlignment && 'text' === element.type"
        class="flex flex-col items-center"
      >
        <div>
          <base-icon-group :class="{ 'cursor-not-allowed': !isFontActive }">
            <base-icon
              :class="{
                'bg-grey': 'left' === element.align,
                'pointer-events-none': !isFontActive
              }"
              name="left-aligned-icon"
              size="sm"
              @click.native="closeModalAfter(() => alignText('left'))"
            />
            <base-icon
              :class="{
                'bg-grey': 'center' === element.align,
                'pointer-events-none': !isFontActive
              }"
              name="centerd-aligned-icon"
              size="sm"
              @click.native="closeModalAfter(() => alignText('center'))"
            />
            <base-icon
              :class="{
                'bg-grey': 'right' === element.align,
                'pointer-events-none': !isFontActive
              }"
              name="right-aligned-icon"
              size="sm"
              @click.native="closeModalAfter(() => alignText('right'))"
            />
          </base-icon-group>
        </div>
        <span class="text-xxs mt-1">
          {{ $t('customization.itemTextAlign') }}
        </span>
      </div>
    </div>
    <div
      v-if="showRotation"
      class="border-b flex items-center justify-between text-black p-2"
      style="line-height: 2"
    >
      <label class="w-1/2">{{ $t('label.rotate') }}</label>
      <Slider
        v-model.number="rotation"
        :min="-180"
        :step="5"
        :max="180"
        @change="afterRotationChange"
      />
    </div>
  </div>
</template>
<script>
import Slider from '../components/input/Slider.vue';
import { mapActions } from 'pinia';
import {
  TrackingMixin,
  elementTypeToTrackingName
} from '@/mixins/gtm-tracking';
import { GETTER_FONT_FONT } from '@/store/modules/font/getters';
import { useControlLayerStore } from '@/store-pinia/control-layer';
import ActiveElement from '@/mixins/activeElement';
import Redirect from '@/mixins/redirect';

export default {
  name: 'AlignmentSettingsPanel',
  components: {
    Slider
  },
  mixins: [TrackingMixin, ActiveElement, Redirect],
  props: {
    showRotation: {
      type: Boolean,
      required: false,
      default: true
    },
    itemAlignment: {
      type: Boolean,
      required: false,
      default: true
    },
    layering: {
      type: Boolean,
      required: false,
      default: true
    },
    textAlignment: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    rotation: {
      get() {
        return this.element.rotation;
      },
      set(newRotation) {
        this.updateElement({
          rotation: newRotation
        });
      }
    },
    isFontActive() {
      return this.$store.getters[GETTER_FONT_FONT](this.element.font).active;
    }
  },
  methods: {
    afterRotationChange() {
      this.trackEvent({
        action: elementTypeToTrackingName(this.element.type) + '_Rotate',
        label: this.rotation
      });
      this.closeModal();
    },
    moveToBack() {
      this.trackEvent({
        action: elementTypeToTrackingName(this.element.type) + '_LayerBack'
      });
      this.closeModalAfter(() => this.elementToBack(this.element.uid));
    },
    moveToFront() {
      this.trackEvent({
        action: elementTypeToTrackingName(this.element.type) + '_LayerFront'
      });
      this.closeModalAfter(() => this.elementToFront(this.element.uid));
    },
    centerElementHorizontally() {
      this.updateElement({
        left: 50 - this.element.width / 2
      });
      this.trackEvent({
        action: elementTypeToTrackingName(this.element.type) + '_CenterHoriz'
      });
    },
    centerElementVertically() {
      this.updateElement({
        top: 50 - this.element.height / 2
      });
      this.trackEvent({
        action: elementTypeToTrackingName(this.element.type) + '_CenterVerti'
      });
    },
    alignText(align) {
      if (!this.isFontActive) {
        return;
      }
      this.updateElement({ align });
      this.trackEvent({
        action: 'Text_Align' + align.charAt(0).toUpperCase() + align.slice(1)
      });
    },
    ...mapActions(useControlLayerStore, ['elementToBack', 'elementToFront'])
  }
};
</script>
